// Birthday rows twinkle once when they scroll into view (owner, 2026-08-19).
// Off when the reader prefers reduced motion. No gradient, no shadow.
import { useEffect } from 'preact/hooks';

const REDUCE = '(prefers-reduced-motion: reduce)';

export function useSparkleOnView(root: { current: HTMLElement | null }, watch: string): void {
  useEffect(() => {
    const el = root.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    if (typeof matchMedia === 'function' && matchMedia(REDUCE).matches) return undefined;
    const targets = [...el.querySelectorAll<HTMLElement>('[data-sparkle]')];
    if (!targets.length) return undefined;
    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        entry.target.classList.toggle('is-sparkling', entry.isIntersecting);
      }
    }, { threshold: 0.45 });
    for (const t of targets) io.observe(t);
    return () => io.disconnect();
  }, [root, watch]);
}
